import { FunctionComponent } from 'react';
import PaperLayout from '../layout/PaperLayout';
import MemberList from './components/MemberList';
import { MembersSortDirection, MembersSortOrder } from './memberConstants';
import { usePendingMembers } from './memberService';

const PendingMembers: FunctionComponent = () => {
    const { response: membersResponse, isLoading, error, refetch } = usePendingMembers();

    return (
        <PaperLayout heading="Åtkomstförfrågningar" tightenUp={true} mainClass="pt-4">
            <div className="mb-4">De boende som listas här har laddat ned Mitt Boende-appen och accepterat användarvillkoren.</div>
            <MemberList
                isPending={true}
                defaultSortOrder={MembersSortOrder.FirstName}
                defaultSortDirection={MembersSortDirection.Descending}
                membersResponse={membersResponse}
                isLoading={isLoading}
                error={error}
                refetch={refetch}
            />
        </PaperLayout>
    );
};

export default PendingMembers;
